import React from "react";
import { View, StyleSheet, TouchableOpacity, Platform } from "react-native";
import variables from "../../../../../styles/variables";
import TextLoader from "../shared/TextLoader";
import RectangleLoader from "../shared/RectangleLoader";
import Gap from "../../../../Gap";

const { colors, spacing } = variables;

const RBettingTileLoader: React.FC = () => {
  const isWeb = Platform.OS === "web";

  return (
    <TouchableOpacity style={styles.container}>
      <View style={styles.innerContainer}>
        <View style={styles.bmLogo} />
        <View style={styles.text}>
          <TextLoader width={isWeb ? "80%" : "90%"} />
          <Gap size="xsmall" vertical />
          <TextLoader width={isWeb ? "40%" : "60%"} />
        </View>
        <RectangleLoader width={85} height={35} radius={20} />
      </View>
    </TouchableOpacity>
  );
};

export default RBettingTileLoader;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.palette.neutral.x50,
    borderRadius: 8,
    width: "100%",
  },
  innerContainer: {
    borderStyle: "solid",
    borderColor: "transparent",
    padding: spacing.xsmall,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  bmLogo: {
    marginRight: spacing.xsmall,
    width: 50,
    height: 50,
    backgroundColor: colors.palette.neutral.x100,
    borderRadius: 5,
  },
  text: {
    flex: 2,
  },
});
